import { Observable } from "rxjs";

export class SidenavOption {
    title: () => string;
    icon: () => string;
    onClick: () => Observable<any>;
    visible: () => boolean;
    appearance: () => string;
    tooltip?: string;
}

export class ChangeCollisionEntry {
    oldValue: Observable<any>;
    newValue: Observable<any>;
    type: number;
    attribute: Observable<any>;
}

export const CHANGE_COLLISION_DISPLAY_TYPE = {
    'STRING': 0,
    'HTML': 1,
    'DATE': 2,
    'DATETIME': 3,
    'TIME': 4
}

export class DoubletSuggestion {
    title: string;
    subTitles: { attribute: string, value: string }[];
    identifier: any;
}
